// components/DeviceGroups/AddEditDeviceGroupModal.tsx
import React, { useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import type { DeviceGroup } from '../../types';
import { createDeviceGroup, updateDeviceGroup } from '@/api/devicegroupService';

interface Props {
  open: boolean;
  mode: 'add' | 'edit';
  initialValues?: DeviceGroup;
  onCancel: () => void;
  onSuccess: () => void;
}

const AddEditDeviceGroupModal: React.FC<Props> = ({ open, mode, initialValues, onCancel, onSuccess }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
      if (mode === 'edit' && initialValues) {
        form.setFieldsValue({ name: initialValues.name });
      }
    }
  }, [open, mode, initialValues, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields(); // { name }
      if (mode === 'add') {
        await createDeviceGroup({ name: values.name });
        message.success('Device group created');
      } else if (mode === 'edit' && initialValues) {
        await updateDeviceGroup(Number((initialValues as any).id), { name: values.name });
        message.success('Device group updated');
      }
      onSuccess();
    } catch (err: any) {
      if (err?.errorFields) return; // form errors
      message.error(err?.message || 'Operation failed');
    }
  };

  return (
    <Modal
      open={open}
      title={mode === 'add' ? 'Add Device Group' : 'Edit Device Group'}
      onCancel={onCancel}
      onOk={handleOk}
      okText={mode === 'add' ? 'Create' : 'Save'}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="name"
          label="Group Name"
          rules={[
            { required: true, message: 'Please input group name' },
            { max: 100, message: 'Name is too long' },
          ]}
        >
          <Input placeholder="e.g., Production Group" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditDeviceGroupModal;
